import { type CredentialResponse, GoogleLogin } from '@react-oauth/google';
import type { GoogleOAuthButtonProps } from './google-oauth-button.types';
import { useGoogleOAuthService } from './google-oauth-button.service';
import { useGoogleOAuthButtonPresenter } from './google-oauth-button.presenter';
import { FEATURE_FLAGS } from '../../../constants/feature-flags';

export const GoogleOAuthButton = ({
  context = 'signin',
}: GoogleOAuthButtonProps) => {
  const { containerRef, buttonWidth } = useGoogleOAuthButtonPresenter();
  const { loginWithGoogle, isLoading, handleOAuthError } =
    useGoogleOAuthService();

  // Hide button if Google OAuth is not configured
  if (!FEATURE_FLAGS.googleOAuth) {
    return null;
  }

  const onSuccess = (response: CredentialResponse) => {
    if (isLoading) {
      return;
    }

    if (!response.credential) {
      handleOAuthError({ code: 'missing_token' });
      return;
    }

    loginWithGoogle(response.credential);
  };

  return (
    <div
      ref={containerRef}
      className={`w-full ${isLoading ? 'pointer-events-none opacity-60' : ''}`}
      aria-busy={isLoading}
    >
      {buttonWidth && (
        <GoogleLogin
          onSuccess={onSuccess}
          onError={() => handleOAuthError({ code: 'consent_denied' })}
          text={context === 'signup' ? 'signup_with' : 'signin_with'}
          shape="rectangular"
          width={buttonWidth}
        />
      )}
    </div>
  );
};
